import _ from 'underscore'

let calculate = function (heart_rate, time_to_5m, neuromuscular_balance, cardiorespiratory_state, valueTranscendence, valueSatisfaction, valueHappiness, valueWorry, valueDepression, gender_selected, weight, height, birthday, smoke_selected, mobility, personal_care, daily_activities, pain_discomfort, anxiety_depression) {

  function decimalTwo (n) {
    n = Number(n)
    return Number(n.toFixed(1))
   }
    var $scope = {
    "constants": {
      "reference": {
        "bmi": 27,
        "age": 30,
        "fc": 66
      },
      "risk_factor": {
        "male": {
          "bmi": 0.064,
          "age": 0.1011,
          "smoke": 0.7763,
          "fc": 0.0229,
          "sum1": 0.7763,
          "ten_years": 0.996931,
          "sum2": 0.19,
          "arterial_age": 114.257
        },
        "female": {
          "bmi": 0.0408,
          "age": 0.1415,
          "smoke": 0.9316,
          "fc": 0.0244,
          "sum1": 2.77,
          "ten_years": 0.996169,
          "sum2": 0.133,
          "arterial_age": 100.5164
        }
      },
      "time_to_5m_init_value": 10,
      "cardiopulmonar_calc": {
        "crf_score": [0, 0.32, 1.06, 1.76, 3.03],
        "factors": {
          "gender": 2.77,
          "age": 0.1,
          "bmi": 0.17,
          "fc": 0.03,
          "mets_constant": 14.7,
          "constant": 18.07
        }
      },
      "fx_calc": {
        "k1": 0.9969,
        "balance_per_age": [
          [18, 40, 50, 60, 70, 80, 90, 100],
          [45, 42, 42, 32, 22, 10, 10, 10]
        ]
      }
    },
    "subclinic_risks" : {
      "heart_rate" : 0,
      "time_to_5m" : 0,
      "neuromuscular_balance" : 0
    },
    "cardiorespiratory_state": {
      "value": 0
    },
    "subjective_welfare" : {
      "valueTranscendence": 0,
      "valueSatisfaction": 0,
      "valueHappiness": 0,
      "valueWorry": 0,
      "valueDepression": 0
    },
    "eq_5d": {
      "questions": {
        "mobility": {
          "value": 1
        },
        "personal_care": {
          "value": 1
        },
        "daily_activities": {
          "value": 1
         },
        "pain_discomfort": {
          "value": 1
        },
        "anxiety_depression": {
          "value": 1
        }
      }
    },
    "profile": {
      "smoke_selected": "No",
      "gender_selected": "m",
      "weight": 0,
      "height": 0,
      "birthday": "30/12/1900"
    }
  }

$scope.subclinic_risks.heart_rate = (heart_rate < 50) ? 50 : (heart_rate > 90) ? 90 : heart_rate
$scope.subclinic_risks.time_to_5m = time_to_5m
$scope.subclinic_risks.neuromuscular_balance = (neuromuscular_balance < 10) ? 10 : (neuromuscular_balance > 42) ? 42 : neuromuscular_balance
$scope.cardiorespiratory_state.value = ( cardiorespiratory_state - 1 ) * 25

$scope.subjective_welfare.valueTranscendence  = valueTranscendence * 10
$scope.subjective_welfare.valueSatisfaction = valueSatisfaction * 10
$scope.subjective_welfare.valueHappiness = valueHappiness * 10
$scope.subjective_welfare.valueWorry = valueWorry * 10
$scope.subjective_welfare.valueDepression = valueDepression *10

$scope.profile.gender_selected = gender_selected
$scope.profile.weight = (weight < 50) ? 50 : (weight > 110) ? 110 : weight
$scope.profile.height = height
$scope.profile.birthday =  birthday
$scope.profile.smoke_selected = smoke_selected

$scope.eq_5d.questions.mobility.value = mobility
$scope.eq_5d.questions.personal_care.value = personal_care
$scope.eq_5d.questions.daily_activities.value = daily_activities
$scope.eq_5d.questions.pain_discomfort.value = pain_discomfort
$scope.eq_5d.questions.anxiety_depression.value = anxiety_depression

function calcArterialAge(gender, weight, height, bmi, age, smoke, fc) {
  var deltaBmi = bmi - $scope.constants.reference.bmi;
  var deltaAge = age - $scope.constants.reference.age;
  var deltaFC = fc - $scope.constants.reference.fc;
  var risk_factors = (gender == 'm') ? $scope.constants.risk_factor.male : $scope.constants.risk_factor.female;
  var risk_values1 = {
    "bmi": deltaBmi * risk_factors.bmi,
    "age": deltaAge * risk_factors.age,
    "smoke": (smoke) ? risk_factors.smoke : 0,
    "fc": deltaFC * risk_factors.fc
  }
  var sum1 = risk_values1.bmi + risk_values1.age + risk_values1.smoke + risk_values1.fc;
  var risk_sum1 = Math.exp(sum1 - risk_factors.sum1);
  var risk_ten_years = 1 - Math.pow(risk_factors.ten_years, risk_sum1);
  var temp_sum2 = -Math.log(-(risk_ten_years - 1));
  var risk_sum2 = Math.pow(temp_sum2, risk_factors.sum2);
  return risk_sum2 * risk_factors.arterial_age;
}

function calcFisicalVigor(age, arterial_age, time_to_5m) {
  var initial_value = (time_to_5m <= 6) ? 10 : 3.5;
  var age_decline = ((age - 20) / 2) * 0.1;
  var delta_arterial_age = arterial_age - age;
  var vigor = initial_value - (age_decline + delta_arterial_age * 0.1)
  return (vigor < 3) ? 3 : vigor;
}

function calcEmotionalWelfare(s, h, w, d) {
  emotional_balance = h - ((w + d) / 2);
  emotional_balance = (emotional_balance < 0) ? 0 : emotional_balance;
  return (s + emotional_balance) / 2;
}

function calcCardiopulmonarCapacity(age, bmi, fc, af_score) {
  var ccFactors = $scope.constants.cardiopulmonar_calc.factors;
  var ccf = {
    "gender": (gender == 'm') ? ccFactors.gender : 0,
    "age": age * ccFactors.age,
    "bmi": (bmi < 38) ? ccFactors.bmi * bmi : ccFactors.bmi * 38,
    "fc": (fc < 110) ? ccFactors.fc * fc : ccFactors.fc * 110,
    "af": $scope.constants.cardiopulmonar_calc.crf_score[af_score]
  }
  return ccf.gender - ccf.age - ccf.bmi - ccf.fc + ccf.af + ccFactors.constant;
}

function calcVitalityIndex(smoke, age, arterial_age, fisical_vigor, mets, emotional_balance, satisfaction) {
  var subclinic_risk_cadence = (arterial_age - age) * 0.1;
  subclinic_risk_cadence = (smoke) ? 6 - subclinic_risk_cadence : 10 - subclinic_risk_cadence;
  subclinic_risk = (subclinic_risk_cadence > 10) ? 10 : subclinic_risk_cadence;
  var normalized_mets = (mets > 10) ? 10 : mets;
  return (subclinic_risk + fisical_vigor + normalized_mets + emotional_balance + satisfaction) / 5;
}

function vlookup(index, table) {
  for (var i = 0, l = table[0].length; i < l; i++) {
    if (index == table[0][i]) return table[1][i];
    if (i < l - 1) {
      if (index > table[0][i] && index < table[0][i + 1]) return table[1][i];
    }
    if (i == l) return table[1][l];
  }
}
var biolo
function publishbiologicalage (biological_Age) {
  return biological_Age
}

function calcFunctionalIndex(age, gender, neuromuscular_balance, fisical_vigor, arterial_age, bmi, mets, emotional_welfare) {
  var expected_nmBalance = vlookup(age, $scope.constants.fx_calc.balance_per_age);
  var arterial_function = (arterial_age - age) / arterial_age;
  var metabolic_fx = Math.log(bmi / 25);
  var expected_mets = $scope.constants.cardiopulmonar_calc.factors.mets_constant;
  var c_mets = $scope.constants.cardiopulmonar_calc.factors.mets_constant
  expected_mets = (gender == 'm') ? c_mets - (0.11 * age) : c_mets - (0.13 * age);
  var cardiopulmonar_fx = -Math.log(mets / expected_mets);
  var wellbeing_emotional_balance = -Math.log(emotional_welfare / 10);
  var nm_balance = (neuromuscular_balance > expected_nmBalance) ? 0 : -Math.log(neuromuscular_balance / expected_nmBalance);
  var expected_fx_decline = Math.log(((age - 20) / 2))/10;
  var fx_decline = (arterial_function) + (metabolic_fx) + (cardiopulmonar_fx) + (wellbeing_emotional_balance) + (nm_balance);
  var oe_coefficient = fx_decline / expected_fx_decline;
  biological_age = age + (age * oe_coefficient * 0.05);
  var k1 = $scope.constants.fx_calc.k1;
  var k2 = 1 - expected_fx_decline;
  lost_capacity = 100 * (1 - (Math.pow(k1, Math.exp(fx_decline - k2))));
  percent_lost_capacity = (lost_capacity < 0.8) ? lost_capacity : 0.8;
  percent_lost_capacity *= 100;
  fx_reserve = 100 - percent_lost_capacity;
  arterial_function = (1 - arterial_function) * 10;
  arterial_function = (arterial_function > 10) ? 10 : arterial_function;
  metabolic_fx = (1 - metabolic_fx) * 10;
  metabolic_fx = (metabolic_fx > 10) ? 10 : metabolic_fx;
  cardiopulmonar_fx = (1 - cardiopulmonar_fx) * 10;
  cardiopulmonar_fx = (cardiopulmonar_fx > 10) ? 10 : cardiopulmonar_fx;
  fisical_vigor = (1 - (expected_fx_decline / 10)) * 10;
  nm_balance = (nm_balance > 0.6) ? 0.6 : nm_balance;
  var vigor_neuromuscular = (1 - (expected_fx_decline + nm_balance)) * 10;
  if(isNaN(vigor_neuromuscular)) {
    vigor_neuromuscular = '--'
  }
  return [decimalTwo(arterial_function), decimalTwo(metabolic_fx), decimalTwo(cardiopulmonar_fx), decimalTwo(emotional_welfare), decimalTwo(vigor_neuromuscular)];
}

function calcEQ5D() {
  var eq_5dActivity = $scope.eq_5d;
  var aggregate = ''
  var sum = 0
  _.each(eq_5dActivity.questions, function(a) {
    aggregate+= ''+a.value
    sum+=a.value
  })
  return [aggregate, sum/5]
}

function calcSummaryData() {
  var biological_age = (biological_age > 85) ? 85 : biological_age
  var eq_5d = calcEQ5D()
  var avg_func_indx = (isNaN(average(functional_index))) ? '--' : average(functional_index)
  biological_age = (isNaN(biological_age)) ? '--' : biological_age
  return [decimalTwo(avg_func_indx), decimalTwo(percent_lost_capacity), decimalTwo(fx_reserve), decimalTwo(arterial_age), decimalTwo(biological_age), decimalTwo(eq_5d[0]), decimalTwo(eq_5d[1])]
}

function average(arr) {
  return _.reduce(arr, function(memo, num) {
    return memo + num;
  }, 0) / arr.length;
}

var gender, weight, height, bmi, age, smoke, fc, time_to_5m, neuromuscular_balance,
  af_score, satisfaction, happiness, worry, depression, emotional_balance, subclinic_risk,
  lost_capacity, percent_lost_capacity, fx_reserve, biological_age, transcendence;

// $scope.subclinic_risks = $scope.navStructureObj.phases_content.phase1.subjects[0].activities["subclinic_risks"];
// $scope.cardiorespiratory_state = $scope.navStructureObj.phases_content.phase1.subjects[0].activities["cardiorespiratory_state"];
// $scope.subjective_welfare = $scope.navStructureObj.phases_content.phase1.subjects[0].activities["subjective_welfare"];






gender = $scope.profile.gender_selected;
weight = $scope.profile.weight;
height = $scope.profile.height;
bmi = weight / (Math.pow(height / 100, 2));
var birthday = new Date($scope.profile.birthday.split('/').reverse().join('-'));
var ageDifMs = Date.now() - birthday.getTime();
var ageDate = new Date(ageDifMs);
age = (Math.abs(ageDate.getUTCFullYear() - 1970) < 25) ? 25:(Math.abs(ageDate.getUTCFullYear() - 1970) > 80) ? 80 : Math.abs(ageDate.getUTCFullYear() - 1970)
smoke = ($scope.profile.smoke_selected == "Si") ? true : false;

fc = $scope.subclinic_risks.heart_rate;
time_to_5m = $scope.subclinic_risks.time_to_5m;
neuromuscular_balance = $scope.subclinic_risks.neuromuscular_balance;
af_score = $scope.cardiorespiratory_state.value / 25;
transcendence = $scope.subjective_welfare.valueTranscendence / 10;
satisfaction = (($scope.subjective_welfare.valueSatisfaction / 10) + transcendence) / 2;
happiness = $scope.subjective_welfare.valueHappiness / 10;
worry = $scope.subjective_welfare.valueWorry / 10;
depression = $scope.subjective_welfare.valueDepression / 10;

var arterial_age = calcArterialAge(gender, weight, height, bmi, age, smoke, fc);
var fisical_vigor = calcFisicalVigor(age, arterial_age, time_to_5m);
var emotional_welfare = calcEmotionalWelfare(satisfaction, happiness, worry, depression);

var mets = calcCardiopulmonarCapacity(age, bmi, fc, af_score);
var vitality_index = calcVitalityIndex(smoke, age, arterial_age, fisical_vigor, mets, emotional_balance, satisfaction);
var functional_index = calcFunctionalIndex(age, gender, neuromuscular_balance, fisical_vigor, arterial_age, bmi, mets, emotional_welfare);
$scope.avg_functional_index = average(functional_index);

var capFunc = average(functional_index)

subclinic_risk = (subclinic_risk > 10) ? 10 : subclinic_risk;
mets = (mets > 10) ? 10 : mets;

$scope.global_fx_capacity = [decimalTwo(subclinic_risk), decimalTwo(fisical_vigor), decimalTwo(mets), decimalTwo(emotional_balance), decimalTwo(satisfaction)];


$scope.summaryData = calcSummaryData()

return [($scope.global_fx_capacity), (functional_index), (vitality_index), ($scope.summaryData), (percent_lost_capacity), (fx_reserve), (arterial_age), (biological_age), (capFunc)]
  }

module.exports = calculate



// WEBPACK FOOTER //
// ./src/components/Dashboard/MedicalCalculate.js